module.exports = __webpack_public_path__ + "media/tags/late-game-88865cad.png";